import React from 'react';

import { classes } from './CompletedIcon.st.css';
import { FCWithChildren } from '@wix/challenges-web-library';

export const CompletedIcon: FCWithChildren = () => {
  return (
    <div className={classes.root}>
      <span className={classes.rootCircle}></span>
    </div>
  );
};
